import { render } from "./Blob.vue?vue&type=template&id=4cfeddc0"
import script from "./Blob.vue?vue&type=script&lang=js"
export * from "./Blob.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__